import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import assetPath from "utils/assetPath.utils";
import "./loader.component.scss";
import imagesLoaded from "imagesloaded";

interface Props {
  visible: boolean;
  onLoaded: () => void;
}

const Loader: React.FC<Props> = (props) => {
  const mainRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const main = mainRef.current;
    if (!!main) {
      imagesLoaded(main, () => {
        props.onLoaded();
      });
    }
  }, []);

  return (
    <div className={classNames("loader", { "is-hidden": !props.visible })} ref={mainRef}>
      <img
        src={assetPath("/assets/images/loading_NIP2.gif")}
        className="loader__icon"
        alt=""
      />
    </div>
  );
};

export default Loader;
